import { ASSET_PREFIX } from 'enums/statics'

/** TR bu anniversary asset setine dahil değil. */
export const EXCLUDED_ANNIVERSARY_LANGS = new Set(['tr'])

/** public/wingie-10-years altında bulunan dil SVG'leri */
export const ANNIVERSARY_SVG_LANGS = [
  'ar',
  'az',
  'de',
  'en',
  'es',
  'fr',
  'hi',
  'it',
  'ja',
  'ka',
  'kk',
  'ko',
  'ky',
  'lt',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'sr',
  'ta',
  'tg',
  'th',
  'ur',
  'uz',
  'zh',
] as const

export type AnniversarySvgLang = (typeof ANNIVERSARY_SVG_LANGS)[number]
export type AnniversarySvgVariant = 'white' | 'green' | 'celebrating'

const ANNIVERSARY_SVG_LANG_SET = new Set<string>(ANNIVERSARY_SVG_LANGS)

/** Locale'den dil kodu çıkarır; SVG yoksa veya hariç dilse en'e düşer. */
export const resolveAnniversaryLang = (locale?: string | null): AnniversarySvgLang => {
  if (!locale || locale === 'default') return 'en'
  const lang = locale.includes('-') ? locale.split('-').pop() : locale
  const normalized = (lang || 'en').toLowerCase()
  if (EXCLUDED_ANNIVERSARY_LANGS.has(normalized)) return 'en'
  return ANNIVERSARY_SVG_LANG_SET.has(normalized) ? (normalized as AnniversarySvgLang) : 'en'
}

/**
 * Canlı nginx yalnızca /homepage/_next* yollarını bu app'e verir.
 * SVG'ler .next/static altına kopyalanır; public/ kaynak olarak kalır.
 */
export const getAnniversarySvgUrl = (variant: AnniversarySvgVariant, locale?: string | null): string => {
  const lang = resolveAnniversaryLang(locale)
  return `${ASSET_PREFIX}/_next/static/wingie-10-years/${variant}/${lang}.svg`
}
